import { useEffect, useState } from 'react';
import { BadgeBuilder, type BadgeFormData } from '../admin/BadgeBuilder';
import { adminBadgeService } from '../../services/adminBadgeService';
import { useNotification } from '../../contexts/NotificationContext';

export default function TeacherBadgeEditor() {
  const [badges, setBadges] = useState<BadgeFormData[]>([]);
  const [formData, setFormData] = useState<BadgeFormData | null>(null);
  const [showForm, setShowForm] = useState(false);
  const [isEditing, setIsEditing] = useState(false);
  const [editIndex, setEditIndex] = useState<number | null>(null);
  const { addNotification } = useNotification();

  useEffect(() => {
    const load = async () => {
      try {
        const badgesFromAPI = await adminBadgeService.getAllBadges();
        setBadges(badgesFromAPI);
      } catch (error) {
        console.error('Error loading badges:', error);
        addNotification('Failed to load badges', 'error');
      }
    };

    load();
  }, [addNotification]);

  return (
    <BadgeBuilder
      badges={badges}
      setBadges={setBadges}
      formData={formData}
      setFormData={(data) => setFormData(data)}
      showForm={showForm}
      setShowForm={setShowForm}
      isEditing={isEditing}
      setIsEditing={setIsEditing}
      editIndex={editIndex}
      setEditIndex={setEditIndex}
    />
  );
}
